const FIL = ({ ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0"
      mask-type="alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="20"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 0H20V20H0V0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10 19.9996C4.5 19.9996 0 15.4996 0 9.94959C0.05 4.44959 4.5 -0.0504113 10.05 -0.000411296C15.55 0.0495887 20 4.49959 20 10.0996C19.95 15.5496 15.5 19.9996 10 19.9996Z"
        fill="#0090FF"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.95 8.80001L10.65 10.4L13.5 10.8L13.3 11.55L10.5 11.15C10.3 11.8 10.2 12.5 9.94995 13.1C9.69995 13.8 9.44995 14.5 9.14995 15.15C8.74995 16 8.04995 16.6 7.09995 16.75C6.54995 16.85 5.94995 16.8 5.49995 16.45C5.34995 16.35 5.19995 16.15 5.19995 16C5.19995 15.8 5.29995 15.55 5.44995 15.45C5.54995 15.4 5.79995 15.45 5.94995 15.5C6.09995 15.65 6.24995 15.85 6.34995 16.05C6.64995 16.45 7.04995 16.5 7.44995 16.2C7.89995 15.8 8.14995 15.25 8.29995 14.7C8.59995 13.5 8.89995 12.35 9.14995 11.15V10.95L6.49995 10.55L6.59995 9.80001L9.34995 10.2L9.69995 8.65001L6.84995 8.20001L6.94995 7.40001L9.89995 7.80001C9.99995 7.50001 10.05 7.25001 10.15 7.00001C10.4 6.10001 10.65 5.20001 11.25 4.40001C11.85 3.60001 12.55 3.10001 13.6 3.15001C14.05 3.15001 14.5 3.30001 14.8 3.65001C14.85 3.70001 14.95 3.80001 14.95 3.90001C14.95 4.10001 14.95 4.35001 14.8 4.50001C14.6 4.65001 14.35 4.60001 14.15 4.40001C14 4.25001 13.9 4.10001 13.75 3.95001C13.45 3.55001 13 3.50001 12.65 3.85001C12.4 4.10001 12.15 4.45001 12 4.80001C11.65 5.85001 11.4 6.95001 11.05 8.05001L13.8 8.45001L13.6 9.20001L10.95 8.80001"
        fill="white"
      />
    </g>
  </svg>
);
export default FIL;
